import { render } from "./MyAppIcon.vue?vue&type=template&id=4361ecff&scoped=true"
import script from "./MyAppIcon.vue?vue&type=script&lang=js"
export * from "./MyAppIcon.vue?vue&type=script&lang=js"

import "./MyAppIcon.vue?vue&type=style&index=0&id=4361ecff&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4361ecff"]])

export default __exports__